import { render, staticRenderFns } from "./Signup-by-IIn.vue?vue&type=template&id=6c9a2c35&scoped=true"
import script from "./Signup-by-IIn.vue?vue&type=script&lang=js"
export * from "./Signup-by-IIn.vue?vue&type=script&lang=js"
import style0 from "./Signup-by-IIn.vue?vue&type=style&index=0&id=6c9a2c35&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a2c35",
  null
  
)

export default component.exports